"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFilePrompt = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledFilePrompt = styled_components_1.default.div `
  align-items: center;
  border: 1px dashed ${config_1.colors.huron};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 95px;
  width: 100%;

  &:hover,
  &:focus {
    border-color: ${config_1.colors.indigo};
    outline: none;
  }
`;
